import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification__badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_icon = _resolveComponent("s-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "s-header__notification-wrapper q-mr-md",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeVisible && _ctx.changeVisible(...args)))
  }, [
    (_ctx.haveNotifications)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.countNotifications), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_s_icon, {
      class: "s-header-notification_icon notification",
      name: "app:notifications",
      size: "large"
    })
  ]))
}